// Client Dependency Framework Version
// If there is a new version of CDV (?cdv=*) within 
// the next page, force reload.

import barba from 'barba'

function getCdvFromString(str) {
    const match = str.match(/[?&]cdv=([0-9]+)/m)
    return match ? match[1] : ""
}

const currentCdv = getCdvFromString(document.querySelector('link[href*="?cdv="],link[href*="&cdv="]').getAttribute("href"))

let error = false

const testCdv = function TestCdv({ next }) {
    if (error || !next || !next.html) {
        return
    }
    if (getCdvFromString(next.html) !== currentCdv) {
        console.warn("Client Dependency version has change, force a page load.")
        barba.force(next.url.href)
        error = true
    }
}

barba.hooks.beforeLeave(testCdv)
barba.hooks.afterLeave(testCdv)